import { LoaderFunction, useLoaderData, useNavigate } from "react-router-dom";

import { get } from "api";
import { ShopMembershipListItem } from "molecules/containers/shop-membership-list-item/ShopMembershipListItem";
import { queryClient } from "pages/Root";
import { loadIfFlag } from "services/Flags";
import { waitObj } from "toolbox/Promise";

import { ShopListHeader } from "./ShopListHeader/ShopListHeader";

const loader = async () => {
  const theme = queryClient.fetchQuery(["/platform/theme"], () =>
    get("/platform/theme")
  );
  const weightLossPrograms = queryClient.fetchQuery(
    ["/healthie/subscriptions"],
    () => get("/healthie/subscriptions")
  );
  return waitObj({ theme, weightLossPrograms });
};

type LoaderData = Awaited<ReturnType<typeof loader>>;
export const shopWeightLossProgramsLoader: LoaderFunction = loadIfFlag(
  "repeatmd-glp"
)(() => {
  return loader();
});

const ShopWeightLossProgramsPage = () => {
  const { theme, weightLossPrograms } = useLoaderData() as LoaderData;
  const headerImage = theme.resources?.find(
    (resource) => resource.key === "individual-treatments-header"
  )?.url;
  const navigate = useNavigate();

  return (
    <div className="flex flex-col bg-two">
      <ShopListHeader
        title="Weight Loss Programs"
        subtitle="Shop our weight loss programs"
        bgGradient
        backgroundImageUrl={headerImage}
      />
      {weightLossPrograms.map((weightLossProgram) => {
        return (
          <ShopMembershipListItem
            key={weightLossProgram.id}
            title={weightLossProgram.name}
            includedList={[]}
            imageUrl={weightLossProgram.imageUrl}
            price={weightLossProgram.monthlyCost}
            detailMessage={"Sign Up Now"}
            onClick={() =>
              navigate(`/pdp/weight-loss-program/${weightLossProgram.id}`)
            }
          />
        );
      })}
    </div>
  );
};

export default ShopWeightLossProgramsPage;
